/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  Select,
  MenuItem,
  TextField,
  FormControl,
  SelectChangeEvent,
  Typography,
  InputAdornment,
  Box,
} from '@mui/material';
import { TipoParametro } from 'utils/models/types';
import { crearOpcionesTipos } from 'utils/utilities';
import { LoadingButton } from '@mui/lab';
import { StickyNote2Outlined } from '@mui/icons-material';
import { theme } from 'theme/theme';
import { useSelector, useDispatch } from 'react-redux';
import { fetchParametroId } from 'utils/redux/features/parametrosPorIdSlice';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import Spinner from 'components/public/Spinner/Spinner';
import Alerta from 'components/public/Alerta.tsx/Alerta';
import PantallaExito from 'components/public/PantallaExito/PantallaExito';

interface FormularioParametrosProps {
  parametros: TipoParametro[];
  tipo: 'descuento' | 'cuota';
  onSubmit: (parametro: TipoParametro) => void;
  loading: boolean;
  mensajeExito: string;
  mensajeError: string | null;
  onVolver: () => void;
}

const FormParametros = ({
  parametros,
  onSubmit,
  tipo,
  loading,
  mensajeExito,
  mensajeError,
  onVolver,
}: FormularioParametrosProps) => {
  const opcionesParametros = crearOpcionesTipos(parametros, 'TipoParametro');
  const [selectedId, setSelectedId] = useState<number | string>(opcionesParametros[0]?.id || 1);
  const [valorParametro, setValorParametro] = useState<number | string>('');

  const { parametroPorId, loadingParametroPorId } = useSelector((state: RootState) => state.parametroPorId);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (parametroPorId && parametroPorId.Id === selectedId) {
      setValorParametro(parametroPorId.Valor);
    }
  }, [parametroPorId, selectedId, tipo]);

  useEffect(() => {
    dispatch(fetchParametroId(Number(selectedId)));
  }, [tipo]);

  const handleSelectChange = (event: SelectChangeEvent<string | number>) => {
    const selectedValue = event.target.value;
    dispatch(fetchParametroId(Number(selectedValue)));
    setSelectedId(selectedValue);
  };

  const handleValorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValorParametro(event.target.value);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (selectedId && valorParametro !== '') {
      const selectedParam = parametros.find(param => param.Id === Number(selectedId));
      if (selectedParam) {
        const updatedParam: TipoParametro = {
          ...selectedParam,
          Valor: Number(valorParametro), // Convierte a número si es necesario
        };
        onSubmit(updatedParam);
      }
    }
  };

  return (
    <FormControl variant="filled" sx={{ width: '100%', margin: 'auto' }}>
      {!!mensajeError && <Alerta mensaje={mensajeError} abierto={!!mensajeError} severity="error" />}
      {mensajeExito && onVolver ? (
        <Box margin="auto" width="100%">
          <PantallaExito
            titulo="Modificación realizada con éxito!"
            mensaje={mensajeExito}
            onVolver={onVolver}
            subMensaje=" "
          />
        </Box>
      ) : (
        <Box maxWidth="500px" margin="auto">
          <Typography variant="h5" fontSize="27px" color={theme.palette.primary.main} textAlign="left" mb={4}>
            {`Editar valores de ${tipo}`}
          </Typography>
          <Select value={selectedId} onChange={handleSelectChange} variant="filled" label="Suscripción" fullWidth>
            {opcionesParametros &&
              opcionesParametros.map(({ entidad, nombre, id }) => (
                <MenuItem key={`${entidad}-${id}`} value={id}>
                  {nombre}
                </MenuItem>
              ))}
          </Select>
          {loadingParametroPorId ? (
            <Spinner />
          ) : (
            selectedId && (
              <TextField
                label="Valor"
                value={valorParametro}
                onChange={handleValorChange}
                type="number"
                variant="filled"
                sx={{ marginTop: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">{tipo === 'cuota' ? '$' : '%'}</InputAdornment>,
                }}
                fullWidth
              />
            )
          )}
          <LoadingButton
            type="button"
            size="large"
            variant="contained"
            fullWidth
            loading={loading}
            loadingPosition="start"
            startIcon={<StickyNote2Outlined />}
            sx={{ mt: 4, backgroundColor: theme.palette.secondary.main }}
            onClick={handleClick}
          >
            Actualizar
          </LoadingButton>
        </Box>
      )}
    </FormControl>
  );
};

export default FormParametros;
